import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { titleForPath } from "../lib/titles.ts";

/** On every navigation: scroll to the top and set the per-route document title. */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = titleForPath(pathname);
  }, [pathname]);

  return null;
}
